import { render, staticRenderFns } from "./Totalhours.vue?vue&type=template&id=71f58f1c"
import script from "./Totalhours.vue?vue&type=script&lang=js"
export * from "./Totalhours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports